import React from 'react';
import './style.scss';

const data = [{
  sort: '1',
  content: 'Attention for Adversarial Attacks: \nearning from your Mistakes.Florian\n Jaeckle, Aleksandr Agadzhanov,\n JINGYUE LU, M. Pawan Kumar.'
}, {
  sort: '2',
  content: 'Demystifying the Adversarial\n Robustness of Random Transformation\n Defenses. Chawin Sitawarin, Zachary\n Golan-Strieb, David Wagner.'
}, {
  sort: '3',
  content: 'Revisiting Adversarial Robustness of\n Classifiers With a Reject Option. Jiefeng\n Chen, Jayaram Raghuram, Jihye Choi, Xi\n Wu, Yingyu Liang, Somesh Jha.'
}]

export default function BestPaperAwards() {
  return (
    <div className="page-best-paper-awards">
      <div className="paper-awards-title">Best Paper Awards</div>
      <div className="paper-awards-desc">We offer $1000 for each of the following papers.</div>
      <div className="paper-awards-content">
        {
          data.map(item => (
            <div className="content-item" key={item.sort}>
              <div className="detail">{item.content}</div>
              <div className="sort">{item.sort}</div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
